import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import dayjs from "dayjs";
import CandidateBoard from "../../components/HireCRM/CandidateBoard/CandidateBoard";
import CreateCandidatePopup from "../../components/HireCRM/CandidateBoard/CreateCandidatePopup/CreateCandidatePopup";

const CandidateBoardPage = () => {
  const [currentDate, setCurrentDate] = useState(dayjs());

  const handlePrev = () => setCurrentDate((d) => d.subtract(1, "month"));
  const handleNext = () => setCurrentDate((d) => d.add(1, "month"));

  return (
    <DndProvider backend={HTML5Backend}>
      <Box
        sx={{
          flexWrap: { xs: "wrap", lg: "nowrap" },
          display: "flex",
          justifyContent: "center",
          mb: 2,
        }}
      >
        <CreateCandidatePopup />
      </Box>
      <Box
        sx={{
          flexWrap: { xs: "wrap", lg: "nowrap" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Button onClick={handlePrev}>Previous</Button>
        <Typography sx={{ mx: 2 }}>
          {currentDate.format("MMMM YYYY")}
        </Typography>
        <Button onClick={handleNext}>Next</Button>
      </Box>
      <CandidateBoard
        month={currentDate.month() + 1}
        year={currentDate.year()}
      />
    </DndProvider>
  );
};

export default CandidateBoardPage;
